import Vue from 'vue'
import Router from 'vue-router'
import Home from "../views/Home.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    }, {
        path: "/",
        name: "Home",
        component: Home,
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                status: true,
                meta: {
                    title: '系统首页'
                },
                component: () => import (
                "../views/Dashboard.vue")
            }, {
                path: "/table",
                name: "basetable",
                status: true,
                meta: {
                    title: '企业列表'
                },
                component: () => import (
                "../views/BaseTable.vue")
            }, {
                path: "/detail",
                name: "detail",
                status: true,
                meta: {
                    title: '企业详情'
                },
                component: () => import (
                "../views/detail.vue")
            },{
                path: "/charts",
                name: "basecharts",
                status: true,
                meta: {
                    title: '图表'
                },
                component: () => import (
                "../views/BaseCharts.vue")
            }, {
                path: "/alycharts",
                name: "charts",
                status: true,
                meta: {
                    title: '分析图表'
                },
                component: () => import (
                "../views/Chart.vue")
            }, {
                path: '/adduser',
                name: 'adduser',
                status: true,
                meta: {
                    title: '用户管理'
                },
                component: () => import (
                '../views/Adduser.vue')
            }, {
                path: "/high",
                name: "hightech",
                status: true,
                meta: {
                    title: '高新企业'
                },
                component: () => import (
                "../views/HighTech.vue")
            },{
                path: "/mycollect",
                name: "mycollect",
                status: true,
                meta: {
                    title: '我的收藏'
                },
                component: () => import (
                "../views/MyCollect.vue")
            },{
                path: "/upload",
                name: "upload",
                status: true,
                meta: {
                    title: '文件上传'
                },
                component: () => import (
                "../views/Upload.vue")
            },{
                path: "/analyse",
                name: "analyse",
                status: true,
                meta: {
                    title: '行业分析'
                },
                component: () => import (
                "../views/IndustryAnalyse.vue")
            },{
                path: "/key",
                name: "key",
                status: true,
                meta: {
                    title: '重点创企'
                },
                component: () => import (
                "../views/KeyPoint.vue")
            },{
                path: "/professional",
                name: "professional",
                status: true,
                meta: {
                    title: '专精特新'
                },
                component: () => import (
                "../views/Professional.vue")
            },{
                path: "/report",
                name: "report",
                status: true,
                meta: {
                    title: '分析报告'
                },
                component: () => import (
                "../views/Report.vue")
            }
        ]
    }, {
        path: "/login",
        name: "login",
        meta: {
            title: '登录'
        },
        component: () => import (
        "../views/Login.vue")
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js